import { MarketingSubtitlesPanelView } from "./MarketingSubtitlesPanelView";
import { useMarketingSubtitlesPanelState } from "./useMarketingSubtitlesPanelState";

export const MarketingSubtitlesPanel = () => {
  const panelState = useMarketingSubtitlesPanelState();

  return <MarketingSubtitlesPanelView {...panelState} />;
};
